import React from "react"
import { ProSidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';

const SideBar = () =>{
    return(
    <ProSidebar>
  <Menu iconShape="square" style={{color:"black", backgroundColor:"white"}}>
    <MenuItem>Filter</MenuItem>
    <label>Genre:</label>
    <MenuItem>
    <select>
        <option value="Action">Action</option>
        <option value="Adventure">Adventure</option>
        <option value="Animation">Animation</option>
        <option value="Comedy">Comedy</option>
        <option value="Crime">Crime</option>
        <option value="Documentary">Documentary</option>
        <option value="Drama">Drama</option>
        <option value="Family">Family</option>
    </select>
        </MenuItem>
        <label>Rating:</label>
        <MenuItem></MenuItem>
        <label>Duration:</label>
        <MenuItem><input type="number"></input></MenuItem>
        <label>Release Year:</label>
        <MenuItem><input type="number"></input></MenuItem>
        <button>Filter</button>
        <button>Reset</button>
    {/* <SubMenu title="Components">
      <MenuItem>Component 1</MenuItem>
      <MenuItem>Component 2</MenuItem>
    </SubMenu> */}
  </Menu>
</ProSidebar>
)
}
export default SideBar

